import React, { useEffect, useState, useRef } from 'react'
import SVG from 'react-inlinesvg'
import arrow from '../../../../_metronic/images/arr072.svg'
import { GET_AGENTS_BY_SALES_CHANNEL_ID } from '../../../../utils/GraphQLAPI'
import { useLazyQuery } from '@apollo/client'
import _ from 'lodash'

export default function AgentsFilter({ colors, salesChannelIds, setFilterOptions, setRecordingFilter }: any) {
  const [options, setOptions] = useState<any>([])
  const [searchOptions, setSearchOption] = useState<any>("")
  const [selectedOptions, setSelectedOption] = useState<any>([])

  const inputRef = useRef<any>();

  useEffect(() => {
    // initialize debounce function to search once user has stopped typing every half second
    inputRef.current = _.debounce(search, 500);
  }, []);

  useEffect(() => {
    getAgentListForFilter({
      variables: {
        salesChannelIds
      },
    })
  }, [salesChannelIds])

  // Filter Query
  const [getAgentListForFilter] = useLazyQuery(GET_AGENTS_BY_SALES_CHANNEL_ID, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setOptions(
        data.getAgentsBySalesChannelIds.agents.map((x: any) => ({
          checked: false,
          ...x,
        }))
      )
      setSelectedOption([])
    },
  })

  // Search the dropdown value
  const search = (event: any) => {
    setSearchOption(event?.target?.value)
  }

  // Clear all the selected Checkbox
  const clearAllCheckbox = async () => {
    setSelectedOption([])
    setSearchOption('')
    getAgentListForFilter({
      variables: {
        salesChannelIds
      }
    })
    setRecordingFilter((prev: any) => ({ ...prev, agentlIds: null }))
    setFilterOptions((prev: any) => ({ ...prev, agentIds: null }))
  }

  // Function to select and unselect the checkboxes
  const onSelect = async (e: any, data: any) => {
    setOptions((prev: any) => ({ ...prev }))
    if (e.target.checked) {
      setSelectedOption([...selectedOptions, data.agentId])
      setOptions((prev: any) => {
        return options.map((item: any) => {
          if (item.agentId === data.agentId) {
            return { ...item, checked: true }
          }
          return item
        })
      })
    } else {
      const dataPresent: any = selectedOptions?.indexOf(data.agentId)
      selectedOptions.splice(dataPresent, 1)
      setSelectedOption(selectedOptions)
      setOptions(() => {
        return options.map((item: any) => {
          if (item.agentId === data.agentId) {
            return { ...item, checked: false }
          }
          return item
        })
      })
    }
  }

  // Applying Filters to query the data
  const applyFilters = () => {
    setSearchOption('')
    if (selectedOptions.length === 0) {
      setFilterOptions((prev: any) => ({ ...prev, "agentIds": null }))
      setRecordingFilter((prev: any) => ({ ...prev, "agentlIds": null }))
    } else {
      setFilterOptions((prev: any) => ({ ...prev, "agentIds": selectedOptions }))
      setRecordingFilter((prev: any) => ({ ...prev, "agentlIds": selectedOptions }))
    }
  }

  return (
    <>
      <div
        className='h-38px border-0 rounded'
      >
        <a
          className='btn btn-sm d-flex align-items-center justify-content-between w-170px'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          style={{
            borderRadius: '6px',
            height: '43px',
            width: '218px',
            background: '#ffff',
            color: '#7E8299',
            paddingLeft: '30px',
          }}
        >
          {selectedOptions.length === 0 ? "All Agents" : `${selectedOptions.length} Selected`}
          <span className={`svg-icon svg-icon-2`}>
            <SVG src={arrow} width='22px' height='22px' />
          </span>
        </a>

        {/* begin::Menu */}
        <div
          className=' menu menu-sub menu-sub-dropdown'
          style={{ width: '220px' }}
          data-kt-menu='true'
        >
          <div className='mx-1 my-1 menu-item' data-kt-sticky-top='auto'>
            <input
              type='text'
              style={{ width: '210px' }}
              placeholder='Search'
              className='form-control form-control-solid'
              value={searchOptions}
              onChange={(e) => {
                search(e)
              }}
            />
          </div>
          <div
            className='menu-column menu-gray-600 overlay-y menu-state-bg-primary fs-7 py-4 w-160px'
            style={{
              width: '215px',
              maxHeight: '304px',
              borderRadius: '6px',
              overflowY: 'scroll',
            }}
          >
            {options.filter((item: any) => `${item.agentFirstName} ${item.agentLastName}`.toLowerCase()
              .includes(searchOptions?.toLowerCase())).map((optionData: any, index: any) => {
                return (
                  <div
                    className='menu-item w-160px'
                    style={{ width: '200px ', padding: '12px 16px' }}
                    key={index}
                  >
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={optionData?.checked}
                        value={optionData.agentFirstName}
                        onClick={(e) => {
                          onSelect(e, optionData)
                        }}
                      />
                      <label
                        htmlFor=''
                        style={{ color: '#5E6278' }}
                        className='form-check-label fw-semibold fs-5'
                      >
                        {optionData["agentFirstName"]} {optionData["agentLastName"]}
                      </label>
                    </div>
                  </div>
                )
              })}
          </div>
          <div className='menu-item my-1'>
            <button
              className='btn btn-secondary w-59px h-36px mx-4 p-0'
              style={{ width: '85px', height: '36px', marginBottom: '10px', marginRight: '10px', fontSize: '13px' }}
              onClick={clearAllCheckbox}
            >
              Clear
            </button>
            <button
              className='btn btn-primary w-59px h-36px mx-2 me-3 p-0'
              style={{ width: '85px', height: '36px', marginBottom: '10px', marginRight: '10px', fontSize: '13px' }}
              onClick={applyFilters}
              data-kt-menu-dismiss='true'
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
